import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d51928dmdo3ncn62hc60', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        alert('تم الاشتراك بنجاح! شكراً لك');
        form.reset();
      } else {
        alert('حدث خطأ، يرجى المحاولة مرة أخرى');
      }
    } catch (error) {
      alert('حدث خطأ، يرجى المحاولة مرة أخرى');
    }
  };

  return (
    <footer className="bg-gradient-to-br from-primary-900 via-primary-800 to-primary-900 text-white rounded-t-[40px] mt-20 relative">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Column 1 */}
          <div className="md:col-span-1">
            <h3 className="text-2xl font-bold font-cairo mb-4">
              انضم لآلاف الطلاب
            </h3>
            <p className="text-white/80 font-tajawal text-sm leading-relaxed">
              اكتشف فرصتك التعليمية المثالية من بين مئات الخيارات المتاحة في الجامعات السعودية
            </p>
          </div>

          {/* Column 2 */}
          <div>
            <h4 className="text-lg font-bold font-cairo mb-4">روابط سريعة</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/70 hover:text-white transition-colors font-tajawal cursor-pointer">
                  الرئيسية
                </Link>
              </li>
              <li>
                <Link to="/opportunities" className="text-white/70 hover:text-white transition-colors font-tajawal cursor-pointer">
                  الجامعات
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-white/70 hover:text-white transition-colors font-tajawal cursor-pointer">
                  الأسئلة الشائعة
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-white/70 hover:text-white transition-colors font-tajawal cursor-pointer">
                  المدونة
                </Link>
              </li>
              <li>
                <a href="#contact" className="text-white/70 hover:text-white transition-colors font-tajawal cursor-pointer">
                  اتصل بنا
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3 */}
          <div>
            <h4 className="text-lg font-bold font-cairo mb-4">تابعنا</h4>
            <div className="flex flex-col gap-3">
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white/70 hover:text-white transition-colors cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-twitter-x-line text-xl"></i>
                </div>
                <span className="font-tajawal">تويتر</span>
              </a>
              <a
                href="https://snapchat.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white/70 hover:text-white transition-colors cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-snapchat-line text-xl"></i>
                </div>
                <span className="font-tajawal">سناب شات</span>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white/70 hover:text-white transition-colors cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-instagram-line text-xl"></i>
                </div>
                <span className="font-tajawal">انستغرام</span>
              </a>
            </div>
          </div>

          {/* Column 4 */}
          <div>
            <h4 className="text-lg font-bold font-cairo mb-4">اشترك في النشرة</h4>
            <p className="text-white/70 font-tajawal text-sm mb-4">
              احصل على آخر التحديثات حول فرص القبول
            </p>
            <form className="flex gap-2" id="newsletter-form" data-readdy-form onSubmit={handleNewsletterSubmit}>
              <input
                type="email"
                name="email"
                placeholder="بريدك الإلكتروني"
                className="flex-1 px-4 py-2.5 rounded-full bg-white/10 border border-white/20 text-white placeholder:text-white/50 focus:outline-none focus:border-white/40 font-tajawal text-sm"
                required
              />
              <button
                type="submit"
                className="w-12 h-12 flex items-center justify-center bg-white rounded-full hover:bg-white/90 transition-colors cursor-pointer"
                aria-label="اشترك"
              >
                <i className="ri-arrow-left-line text-primary-700 text-xl"></i>
              </button>
            </form>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/60 font-tajawal text-sm">
            © {currentYear} بوابة القبول الجامعي. جميع الحقوق محفوظة
          </p>
          <a
            href="https://readdy.ai/?origin=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white/60 hover:text-white font-tajawal text-sm transition-colors cursor-pointer"
          >
            Powered by AAIT
          </a>
        </div>
      </div>

      {/* Background Text */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-white/5 text-8xl font-bold font-cairo pointer-events-none whitespace-nowrap">
        بوابة القبول
      </div>
    </footer>
  );
}
